export default "__VITE_ASSET__DaIwk3OE__"